<div class="dialog-header">
  <div class="dialog-header-title">{{ 'tournament.endResult.title' | translate }}</div>

  <div class="dialog-header-close-button">
    <button (click)="close()">
      <svg-icon
        src="assets/img/icons/dialog-close.svg"
        [stretch]="true"
        [applyClass]="true"
        class="dialog-header-close-button-icon"
      />
    </button>
  </div>
</div>

<div class="dialog-content">
  <div class="app-tournament-dialog-end-result-position">
    <img class="app-tournament-dialog-end-result-position-image"
      src="assets/common/tournament/{{
        dialogData.position <= 3 ? dialogData.position : 'generic'
      }}-place.png"
      alt="*"
    />
    <div class="app-tournament-dialog-end-result-position-player-name">
        {{ dialogData.playerName }}
    </div>
  </div>

  <div class="app-tournament-dialog-end-result-name">
    {{ dialogData.tournamentName }}
  </div>
  <div class="app-tournament-dialog-end-result-finished">
    <div class="app-tournament-dialog-end-result-finished-icon">
      <svg-icon
        src="assets/common/tournament/ranking.svg"
        [stretch]="true"
        [applyClass]="true"
        class="app-tournament-dialog-end-result-finished-icon-image"
      />
    </div>
    <div class="app-tournament-dialog-end-result-finished-text">
      {{ 'tournament.endResult.finished' | translate }}
      {{ dialogData.position }} / {{ dialogData.nbPlayerRegistered }}
    </div>
  </div>
  <div
    class="app-tournament-dialog-end-result-amount-won"
    *ngIf="dialogData.amountWon > 0"
  >
    <div class="app-tournament-dialog-end-result-amount-won-icon">
      <svg-icon
        src="assets/common/tournament/winning.svg"
        [stretch]="true"
        [applyClass]="true"
        class="app-tournament-dialog-end-result-amount-won-image"
      />
    </div>
    <div class="app-tournament-dialog-end-result-amount-won-text">
      {{ 'tournament.endResult.won' | translate }}: {{ dialogData.amountWon | gcy : dialogData.currency }}
    </div>
  </div>

  <div class="dialog-footer">
    <div class="dialog-footer-buttons">
      <button appButton type="button" (click)="close()" >{{ 'tournament.endResult.ok' | translate }}</button>
      <button *ngIf="false" appButton type="button" (click)="goToLobby()" >{{ 'tournament.endResult.goToLobby' | translate }}</button>
    </div>
  </div>
</div>
